export const COUNTRY_CODES = [
    { code: '+93', name: 'Afghanistan', digits: 9 },
    { code: '+355', name: 'Albania', digits: 9 },
    { code: '+213', name: 'Algeria', digits: 9 },
    { code: '+1', name: 'American Samoa', digits: 10 },
    { code: '+376', name: 'Andorra', digits: 6 },
    { code: '+244', name: 'Angola', digits: 9 },
    { code: '+1', name: 'Anguilla', digits: 10 },
    { code: '+1', name: 'Antigua and Barbuda', digits: 10 },
    { code: '+54', name: 'Argentina', digits: 10 },
    { code: '+374', name: 'Armenia', digits: 8 },
    { code: '+297', name: 'Aruba', digits: 7 },
    { code: '+61', name: 'Australia', digits: 9 },
    { code: '+43', name: 'Austria', digits: 10 },
    { code: '+994', name: 'Azerbaijan', digits: 9 },
    { code: '+1', name: 'Bahamas', digits: 10 },
    { code: '+973', name: 'Bahrain', digits: 8 },
    { code: '+880', name: 'Bangladesh', digits: 10 },
    { code: '+1', name: 'Barbados', digits: 10 },
    { code: '+375', name: 'Belarus', digits: 9 },
    { code: '+32', name: 'Belgium', digits: 9 },
    { code: '+501', name: 'Belize', digits: 7 },
    { code: '+229', name: 'Benin', digits: 8 },
    { code: '+1', name: 'Bermuda', digits: 10 },
    { code: '+975', name: 'Bhutan', digits: 8 },
    { code: '+591', name: 'Bolivia', digits: 8 },
    { code: '+387', name: 'Bosnia and Herzegovina', digits: 8 },
    { code: '+267', name: 'Botswana', digits: 8 },
    { code: '+55', name: 'Brazil', digits: 11 },
    { code: '+1', name: 'British Virgin Islands', digits: 10 },
    { code: '+673', name: 'Brunei', digits: 7 },
    { code: '+359', name: 'Bulgaria', digits: 9 },
    { code: '+226', name: 'Burkina Faso', digits: 8 },
    { code: '+257', name: 'Burundi', digits: 8 },
    { code: '+855', name: 'Cambodia', digits: 9 },
    { code: '+237', name: 'Cameroon', digits: 9 },
    { code: '+1', name: 'Canada', digits: 10 },
    { code: '+238', name: 'Cape Verde', digits: 7 },
    { code: '+1', name: 'Cayman Islands', digits: 10 },
    { code: '+236', name: 'Central African Republic', digits: 8 },
    { code: '+235', name: 'Chad', digits: 8 },
    { code: '+56', name: 'Chile', digits: 9 },
    { code: '+86', name: 'China', digits: 11 },
    { code: '+57', name: 'Colombia', digits: 10 },
    { code: '+269', name: 'Comoros', digits: 7 },
    { code: '+242', name: 'Congo (Republic)', digits: 9 },
    { code: '+243', name: 'Congo (DRC)', digits: 9 },
    { code: '+682', name: 'Cook Islands', digits: 5 },
    { code: '+506', name: 'Costa Rica', digits: 8 },
    { code: '+385', name: 'Croatia', digits: 9 },
    { code: '+53', name: 'Cuba', digits: 8 },
    { code: '+357', name: 'Cyprus', digits: 8 },
    { code: '+420', name: 'Czech Republic', digits: 9 },
    { code: '+45', name: 'Denmark', digits: 8 },
    { code: '+253', name: 'Djibouti', digits: 8 },
    { code: '+1', name: 'Dominica', digits: 10 },
    { code: '+1', name: 'Dominican Republic', digits: 10 },
    { code: '+593', name: 'Ecuador', digits: 9 },
    { code: '+20', name: 'Egypt', digits: 10 },
    { code: '+503', name: 'El Salvador', digits: 8 },
    { code: '+240', name: 'Equatorial Guinea', digits: 9 },
    { code: '+291', name: 'Eritrea', digits: 7 },
    { code: '+372', name: 'Estonia', digits: 7 },
    { code: '+268', name: 'Eswatini (Swaziland)', digits: 8 },
    { code: '+251', name: 'Ethiopia', digits: 9 },
    { code: '+298', name: 'Faroe Islands', digits: 6 },
    { code: '+679', name: 'Fiji', digits: 7 },
    { code: '+358', name: 'Finland', digits: 9 },
    { code: '+33', name: 'France', digits: 9 },
    { code: '+594', name: 'French Guiana', digits: 9 },
    { code: '+689', name: 'French Polynesia', digits: 6 },
    { code: '+241', name: 'Gabon', digits: 8 },
    { code: '+220', name: 'Gambia', digits: 7 },
    { code: '+995', name: 'Georgia', digits: 9 },
    { code: '+49', name: 'Germany', digits: 11 },
    { code: '+233', name: 'Ghana', digits: 9 },
    { code: '+350', name: 'Gibraltar', digits: 8 },
    { code: '+30', name: 'Greece', digits: 10 },
    { code: '+299', name: 'Greenland', digits: 6 },
    { code: '+1', name: 'Grenada', digits: 10 },
    { code: '+590', name: 'Guadeloupe', digits: 9 },
    { code: '+1', name: 'Guam', digits: 10 },
    { code: '+502', name: 'Guatemala', digits: 8 },
    { code: '+224', name: 'Guinea', digits: 9 },
    { code: '+245', name: 'Guinea-Bissau', digits: 7 },
    { code: '+592', name: 'Guyana', digits: 7 },
    { code: '+509', name: 'Haiti', digits: 8 },
    { code: '+504', name: 'Honduras', digits: 8 },
    { code: '+852', name: 'Hong Kong', digits: 8 },
    { code: '+36', name: 'Hungary', digits: 9 },
    { code: '+354', name: 'Iceland', digits: 7 },
    { code: '+91', name: 'India', digits: 10 },
    { code: '+62', name: 'Indonesia', digits: 12 },
    { code: '+98', name: 'Iran', digits: 10 },
    { code: '+964', name: 'Iraq', digits: 10 },
    { code: '+353', name: 'Ireland', digits: 9 },
    { code: '+972', name: 'Israel', digits: 9 },
    { code: '+39', name: 'Italy', digits: 10 },
    { code: '+225', name: 'Ivory Coast', digits: 10 },
    { code: '+1', name: 'Jamaica', digits: 10 },
    { code: '+81', name: 'Japan', digits: 10 },
    { code: '+962', name: 'Jordan', digits: 9 },
    { code: '+7', name: 'Kazakhstan', digits: 10 },
    { code: '+254', name: 'Kenya', digits: 9 },
    { code: '+686', name: 'Kiribati', digits: 8 },
    { code: '+850', name: 'Kosovo', digits: 8 },
    { code: '+965', name: 'Kuwait', digits: 8 },
    { code: '+996', name: 'Kyrgyzstan', digits: 9 },
    { code: '+856', name: 'Laos', digits: 9 },
    { code: '+371', name: 'Latvia', digits: 8 },
    { code: '+961', name: 'Lebanon', digits: 8 },
    { code: '+266', name: 'Lesotho', digits: 8 },
    { code: '+231', name: 'Liberia', digits: 7 },
    { code: '+218', name: 'Libya', digits: 9 },
    { code: '+423', name: 'Liechtenstein', digits: 7 },
    { code: '+370', name: 'Lithuania', digits: 8 },
    { code: '+352', name: 'Luxembourg', digits: 9 },
    { code: '+853', name: 'Macau', digits: 8 },
    { code: '+389', name: 'North Macedonia', digits: 8 },
    { code: '+261', name: 'Madagascar', digits: 9 },
    { code: '+265', name: 'Malawi', digits: 9 },
    { code: '+60', name: 'Malaysia', digits: 10 },
    { code: '+960', name: 'Maldives', digits: 7 },
    { code: '+223', name: 'Mali', digits: 8 },
    { code: '+356', name: 'Malta', digits: 8 },
    { code: '+692', name: 'Marshall Islands', digits: 7 },
    { code: '+596', name: 'Martinique', digits: 9 },
    { code: '+222', name: 'Mauritania', digits: 8 },
    { code: '+230', name: 'Mauritius', digits: 7 },
    { code: '+262', name: 'Mayotte', digits: 9 },
    { code: '+52', name: 'Mexico', digits: 10 },
    { code: '+691', name: 'Micronesia', digits: 7 },
    { code: '+373', name: 'Moldova', digits: 8 },
    { code: '+377', name: 'Monaco', digits: 8 },
    { code: '+976', name: 'Mongolia', digits: 8 },
    { code: '+382', name: 'Montenegro', digits: 8 },
    { code: '+1', name: 'Montserrat', digits: 10 },
    { code: '+212', name: 'Morocco', digits: 9 },
    { code: '+258', name: 'Mozambique', digits: 9 },
    { code: '+95', name: 'Myanmar', digits: 9 },
    { code: '+264', name: 'Namibia', digits: 9 },
    { code: '+674', name: 'Nauru', digits: 7 },
    { code: '+977', name: 'Nepal', digits: 10 },
    { code: '+31', name: 'Netherlands', digits: 9 },
    { code: '+687', name: 'New Caledonia', digits: 6 },
    { code: '+64', name: 'New Zealand', digits: 9 },
    { code: '+505', name: 'Nicaragua', digits: 8 },
    { code: '+227', name: 'Niger', digits: 8 },
    { code: '+234', name: 'Nigeria', digits: 10 },
    { code: '+683', name: 'Niue', digits: 4 },
    { code: '+672', name: 'Norfolk Island', digits: 6 },
    { code: '+1', name: 'Northern Mariana Islands', digits: 10 },
    { code: '+850', name: 'North Korea', digits: 8 },
    { code: '+47', name: 'Norway', digits: 8 },
    { code: '+968', name: 'Oman', digits: 8 },
    { code: '+92', name: 'Pakistan', digits: 10 },
    { code: '+680', name: 'Palau', digits: 7 },
    { code: '+970', name: 'Palestine', digits: 9 },
    { code: '+507', name: 'Panama', digits: 8 },
    { code: '+675', name: 'Papua New Guinea', digits: 8 },
    { code: '+595', name: 'Paraguay', digits: 9 },
    { code: '+51', name: 'Peru', digits: 9 },
    { code: '+63', name: 'Philippines', digits: 10 },
    { code: '+48', name: 'Poland', digits: 9 },
    { code: '+351', name: 'Portugal', digits: 9 },
    { code: '+1', name: 'Puerto Rico', digits: 10 },
    { code: '+974', name: 'Qatar', digits: 8 },
    { code: '+262', name: 'Réunion', digits: 9 },
    { code: '+40', name: 'Romania', digits: 9 },
    { code: '+7', name: 'Russia', digits: 10 },
    { code: '+250', name: 'Rwanda', digits: 9 },
    { code: '+590', name: 'Saint Barthélemy', digits: 9 },
    { code: '+290', name: 'Saint Helena', digits: 4 },
    { code: '+1', name: 'Saint Kitts and Nevis', digits: 10 },
    { code: '+1', name: 'Saint Lucia', digits: 10 },
    { code: '+590', name: 'Saint Martin', digits: 9 },
    { code: '+508', name: 'Saint Pierre and Miquelon', digits: 6 },
    { code: '+1', name: 'Saint Vincent and the Grenadines', digits: 10 },
    { code: '+685', name: 'Samoa', digits: 7 },
    { code: '+378', name: 'San Marino', digits: 6 },
    { code: '+239', name: 'São Tomé and Príncipe', digits: 7 },
    { code: '+966', name: 'Saudi Arabia', digits: 9 },
    { code: '+221', name: 'Senegal', digits: 9 },
    { code: '+381', name: 'Serbia', digits: 9 },
    { code: '+248', name: 'Seychelles', digits: 7 },
    { code: '+232', name: 'Sierra Leone', digits: 8 },
    { code: '+65', name: 'Singapore', digits: 8 },
    { code: '+1', name: 'Sint Maarten', digits: 10 },
    { code: '+421', name: 'Slovakia', digits: 9 },
    { code: '+386', name: 'Slovenia', digits: 8 },
    { code: '+677', name: 'Solomon Islands', digits: 7 },
    { code: '+252', name: 'Somalia', digits: 8 },
    { code: '+27', name: 'South Africa', digits: 9 },
    { code: '+82', name: 'South Korea', digits: 10 },
    { code: '+211', name: 'South Sudan', digits: 9 },
    { code: '+34', name: 'Spain', digits: 9 },
    { code: '+94', name: 'Sri Lanka', digits: 9 },
    { code: '+249', name: 'Sudan', digits: 9 },
    { code: '+597', name: 'Suriname', digits: 7 },
    { code: '+46', name: 'Sweden', digits: 9 },
    { code: '+41', name: 'Switzerland', digits: 9 },
    { code: '+963', name: 'Syria', digits: 9 },
    { code: '+886', name: 'Taiwan', digits: 9 },
    { code: '+992', name: 'Tajikistan', digits: 9 },
    { code: '+255', name: 'Tanzania', digits: 9 },
    { code: '+66', name: 'Thailand', digits: 9 },
    { code: '+670', name: 'Timor-Leste', digits: 7 },
    { code: '+228', name: 'Togo', digits: 8 },
    { code: '+690', name: 'Tokelau', digits: 4 },
    { code: '+676', name: 'Tonga', digits: 7 },
    { code: '+1', name: 'Trinidad and Tobago', digits: 10 },
    { code: '+216', name: 'Tunisia', digits: 8 },
    { code: '+90', name: 'Turkey', digits: 10 },
    { code: '+993', name: 'Turkmenistan', digits: 8 },
    { code: '+1', name: 'Turks and Caicos Islands', digits: 10 },
    { code: '+688', name: 'Tuvalu', digits: 5 },
    { code: '+256', name: 'Uganda', digits: 9 },
    { code: '+380', name: 'Ukraine', digits: 9 },
    { code: '+971', name: 'UAE', digits: 9 },
    { code: '+44', name: 'UK', digits: 10 },
    { code: '+1', name: 'USA', digits: 10 },
    { code: '+1', name: 'US Virgin Islands', digits: 10 },
    { code: '+598', name: 'Uruguay', digits: 8 },
    { code: '+998', name: 'Uzbekistan', digits: 9 },
    { code: '+678', name: 'Vanuatu', digits: 7 },
    { code: '+379', name: 'Vatican City', digits: 10 },
    { code: '+58', name: 'Venezuela', digits: 10 },
    { code: '+84', name: 'Vietnam', digits: 10 },
    { code: '+681', name: 'Wallis and Futuna', digits: 6 },
    { code: '+967', name: 'Yemen', digits: 9 },
    { code: '+260', name: 'Zambia', digits: 9 },
    { code: '+263', name: 'Zimbabwe', digits: 9 }
];
